var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 453.543,
    height: 453.543,
    viewBox: "0 0 453.543 453.543",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath78",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 340.157h340.157V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 453.543)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(122.398 257.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l2.178.476.97 2.008"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.4 263.436)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "4.257, 4.257",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l28.712 59.411"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.037 324.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l.97 2.007L2.535.42"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.649 322.063)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "4.382, 4.382",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l73.448-74.504 59.45-5.41"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(297.728 241.95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l2.22-.202v-2.23"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(299.949 234.973)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "4.545, 4.545",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0v-88.44l-8.862-118.041"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.917 26.226)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l-.167-2.223-2.135.641"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.272 25.95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "4.535, 4.535",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l-67.966 20.429-179.401-21.695"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.654 24.412)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l-2.213-.268L-.352.959"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.853 27.712)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "4.252, 4.252",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l62.13 40.952"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.758 69.834)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l1.862 1.227-.649 2.133"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.674 77.46)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "4.458, 4.458",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l-48.614 159.942"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.412 239.534)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l-.648 2.133 2.178.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.505 243.142)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#70bde5",
    strokeDasharray: "4.672, 4.672",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l61.611 13.478"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.083 117.62)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a1c74a",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l76.251 134.857h108.985l59.839-105.944L168.224-71.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath78)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(163.127 326.77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(163.127 326.77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#175583",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310.188 242.44)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310.188 242.44)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#175583",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(295.466 24.144)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(295.466 24.144)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#175583",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.56 26.686)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.56 26.686)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#175583",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.739 71.061)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.739 71.061)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#175583",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.883 242.44)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.883 242.44)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#175583",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0a5.12 5.12 0 10-10.24 0A5.12 5.12 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.334 252.476)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a1c74a",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l51.105-88.286L108.986 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.083 117.62)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a1c74a",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l127.356 46.571 117.719-17.658"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(209.013 51.852)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a1c74a",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 3.23,
    d: "M0 0l-33.574 112.337"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.064 248.244)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.027-.1c.08-.314 1.423-4.8 3.337-11.167 2.423-8.057 5.759-19.128 8.606-28.565.542-1.798 3.091-1.784 3.612.02C20.88-21.477 27.035.03 27.215 1.286l.002.015a13.662 13.662 0 01-.675 5.977c-2.498 7.185-10.373 10.999-17.56 8.502A13.744 13.744 0 01-.082.49z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.064 248.244)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.329,
    d: "M0 0l.027-.1c.08-.314 1.423-4.8 3.337-11.167 2.423-8.057 5.759-19.128 8.606-28.565.542-1.798 3.091-1.784 3.612.02C20.88-21.477 27.035.03 27.215 1.286l.002.015a13.662 13.662 0 01-.675 5.977c-2.498 7.185-10.373 10.999-17.56 8.502A13.744 13.744 0 01-.082.49z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.217 249.446)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-.004a14.626 14.626 0 01-1.192 7.57c-2.988 6.669-10.578 10.18-17.588 8.116-7.309-2.153-11.578-9.369-10.375-16.553l-.073-.002.189-.628c.099-.466 8.952-29.829 12.879-42.845.542-1.797 3.09-1.783 3.612.02C-8.752-31.182-.15-1.345-.007-.025z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135.41 279.873)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.117-4.959-11.077-11.077-11.077-6.117 0-11.076 4.96-11.076 11.077s4.959 11.077 11.076 11.077C-4.959 11.077 0 6.117 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.05 248.244)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.027-.1c.08-.314 1.423-4.8 3.337-11.167 2.423-8.057 5.759-19.128 8.606-28.565.542-1.798 3.091-1.784 3.612.02C20.88-21.477 27.035.03 27.215 1.286l.002.015a13.662 13.662 0 01-.675 5.977c-2.498 7.185-10.373 10.999-17.56 8.502A13.744 13.744 0 01-.082.49z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.05 248.244)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.329,
    d: "M0 0l.027-.1c.08-.314 1.423-4.8 3.337-11.167 2.423-8.057 5.759-19.128 8.606-28.565.542-1.798 3.091-1.784 3.612.02C20.88-21.477 27.035.03 27.215 1.286l.002.015a13.662 13.662 0 01-.675 5.977c-2.498 7.185-10.373 10.999-17.56 8.502A13.744 13.744 0 01-.082.49z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(248.202 249.446)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-.004a14.626 14.626 0 01-1.192 7.57c-2.988 6.669-10.578 10.18-17.588 8.116-7.309-2.153-11.578-9.369-10.375-16.553l-.073-.002.189-.628c.099-.466 8.952-29.829 12.879-42.845.542-1.797 3.09-1.783 3.612.02C-8.752-31.182-.15-1.345-.007-.025z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(244.396 279.873)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.117-4.959-11.077-11.077-11.077-6.117 0-11.076 4.96-11.076 11.077s4.959 11.077 11.076 11.077C-4.959 11.077 0 6.117 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.813 116.287)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.027-.1c.08-.314 1.423-4.8 3.337-11.167 2.423-8.057 5.759-19.128 8.606-28.565.542-1.798 3.091-1.784 3.612.02C20.88-21.477 27.035.03 27.215 1.286l.002.015a13.662 13.662 0 01-.675 5.977c-2.498 7.185-10.373 10.999-17.56 8.502A13.744 13.744 0 01-.082.49z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.813 116.287)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.329,
    d: "M0 0l.027-.1c.08-.314 1.423-4.8 3.337-11.167 2.423-8.057 5.759-19.128 8.606-28.565.542-1.798 3.091-1.784 3.612.02C20.88-21.477 27.035.03 27.215 1.286l.002.015a13.662 13.662 0 01-.675 5.977c-2.498 7.185-10.373 10.999-17.56 8.502A13.744 13.744 0 01-.082.49z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.966 117.489)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-.004a14.626 14.626 0 01-1.192 7.57c-2.988 6.669-10.578 10.18-17.588 8.116-7.309-2.153-11.578-9.369-10.375-16.553l-.073-.002.189-.628c.099-.466 8.952-29.829 12.879-42.845.542-1.797 3.09-1.783 3.612.02C-8.752-31.182-.15-1.345-.007-.025z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.16 147.915)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.117-4.959-11.077-11.077-11.077-6.117 0-11.076 4.96-11.076 11.077s4.959 11.077 11.076 11.077C-4.959 11.077 0 6.117 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(282.526 145.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.027-.1c.08-.314 1.424-4.8 3.337-11.167 2.423-8.057 5.759-19.128 8.606-28.565.542-1.798 3.091-1.784 3.612.02C20.88-21.477 27.035.03 27.215 1.286l.002.015a13.662 13.662 0 01-.675 5.977c-2.498 7.185-10.373 10.999-17.56 8.502A13.744 13.744 0 01-.082.49z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(282.526 145.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.329,
    d: "M0 0l.027-.1c.08-.314 1.424-4.8 3.337-11.167 2.423-8.057 5.759-19.128 8.606-28.565.542-1.798 3.091-1.784 3.612.02C20.88-21.477 27.035.03 27.215 1.286l.002.015a13.662 13.662 0 01-.675 5.977c-2.498 7.185-10.373 10.999-17.56 8.502A13.744 13.744 0 01-.082.49z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310.68 146.402)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-.004a14.626 14.626 0 01-1.192 7.57c-2.988 6.669-10.578 10.18-17.588 8.116-7.309-2.153-11.578-9.369-10.375-16.553l-.073-.002.189-.628c.099-.466 8.952-29.829 12.879-42.845.542-1.797 3.09-1.783 3.612.02C-8.752-31.182-.15-1.345-.007-.025z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.873 176.828)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.117-4.959-11.077-11.077-11.077-6.117 0-11.076 4.96-11.076 11.077s4.959 11.077 11.076 11.077C-4.959 11.077 0 6.117 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.794 49.372)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.027-.1c.08-.314 1.423-4.8 3.337-11.167 2.423-8.059 5.76-19.131 8.607-28.57.542-1.797 3.089-1.783 3.61.021C20.88-21.48 27.035.03 27.215 1.286l.002.015a13.657 13.657 0 01-.653 5.913c-2.26 6.6-9.315 10.564-16.111 8.99C3.215 14.528-1.278 7.634-.082.49z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.794 49.372)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.329,
    d: "M0 0l.027-.1c.08-.314 1.423-4.8 3.337-11.167 2.423-8.059 5.76-19.131 8.607-28.57.542-1.797 3.089-1.783 3.61.021C20.88-21.48 27.035.03 27.215 1.286l.002.015a13.657 13.657 0 01-.653 5.913c-2.26 6.6-9.315 10.564-16.111 8.99C3.215 14.528-1.278 7.634-.082.49z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.947 50.574)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-.004c.405 3.808-.614 7.875-3.655 11.42-2.697 3.145-6.69 4.973-10.833 4.907-9.86-.158-16.09-8.699-14.667-17.194l-.073-.002.189-.628c.099-.466 8.955-29.838 12.881-42.852.542-1.796 3.087-1.781 3.608.021C-8.755-31.191-.15-1.345-.007-.025z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.14 81)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-6.117-4.959-11.077-11.077-11.077-6.117 0-11.076 4.96-11.076 11.077s4.959 11.077 11.076 11.077C-4.959 11.077 0 6.117 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.374 162.677)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a1c74a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-28.428-23.045-51.473-51.473-51.473-28.428 0-51.473 23.045-51.473 51.473 0 28.428 23.045 51.473 51.473 51.473C-23.045 51.473 0 28.428 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.17 174.07)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-4.979 5.398-1.341-.574.536 1.375-1.289.057c-.775.037-1.017.464-.922 1.193.051.389.185.92-.005 1.159-.78.984-1.67 1.881-2.702 3.009L-14.754 0zm-61.419 11.61L-72.047.061h14.674l-4.046 11.549m30.718 1.677l-.159-.261 12.562-11.651 4.134 11.912zm-27.268-.008l4.16-11.903 12.806 11.903zm21.908-.627L-49.642.032h27.175l-13.594 12.62m6.104-56.099l.263-.131L.464-4.017c-.673.05-1.037.099-1.402.1-4.635.004-9.271-.037-13.905.027-1.066.015-1.458-.395-1.781-1.328-3.295-9.51-6.636-19.004-9.958-28.505-1.133-3.239-2.251-6.482-3.375-9.724m-12.475-.118l.205.111c-.041.195-.061.399-.126.586-4.433 12.667-8.88 25.33-13.284 38.007-.294.846-.768.955-1.514.952-4.677-.02-9.354-.007-14.032-.013-.359-.001-.719-.061-1.377-.12l30.128-39.523m6.216-5.341l.298-.041 15.72 44.971h-31.723l15.705-44.93"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.955 125.164)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-15.705 44.93h31.723L.298-.041 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.739 130.505)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-30.128 39.522c.658.06 1.018.12 1.377.121 4.677.005 9.355-.007 14.032.012.746.003 1.22-.105 1.514-.951C-8.801 26.027-4.354 13.364.079.697.144.509.164.306.205.11A20.475 20.475 0 010 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.214 130.623)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.124 3.241 2.242 6.485 3.375 9.723 3.322 9.501 6.663 18.996 9.958 28.506.323.933.715 1.343 1.781 1.328 4.634-.064 9.27-.024 13.905-.028.365 0 .729-.05 1.402-.099L.263-.132 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.11 186.721)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l13.594-12.62h-27.175z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.202 187.348)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h16.966L4.159-11.902 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(182.47 187.357)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h16.537l-4.134-11.912L-.159-.261 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.752 185.68)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l4.045-11.549h-14.673L0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.17 174.07)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-14.754l4.052 11.617C-9.67 10.489-1.828 1.982 0 0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.16ecfb65501362cdc48dc0e9a38fc450.svg";
export { ForwardRef as ReactComponent };